import queryString from 'query-string';
import { redirect } from 'react-router-dom';

const redirectWithNewParams = (pathname, queryParams) => {
  const newString = queryString.stringify(queryParams);

  return redirect(`${pathname}?${newString}`);
};

export default redirectWithNewParams;
